import React from "react"

import {ProviderScan} from "components/backoffice/Storage/Provider/Scan/ProviderScan"

export const ProviderScanRoute = (props: any) => {

  return <div>
    <ProviderScan />
  </div>
}